<div (contextmenu)="onContextMenu($event)"
     (dragover)="onDragOver($event)"
     (drop)="onDrop($event)"
     (mousedown)="onCanvasMouseDown($event)"
     (mouseleave)="onCanvasMouseLeave()"
     (mousemove)="onCanvasMouseMove($event)"
     (mouseup)="onCanvasMouseUp()"
     (wheel)="onWheel($event)"
     [class.fc-canvas--connecting]="!!connectionDraft"
     [class.fc-canvas--marquee]="isMarqueeActive"
     class="fc-canvas">
  <div [style.transform]="'translate(' + panX + 'px,' + panY + 'px) scale(' + zoom + ')'"
       class="fc-transform-layer">

    <!-- SVG layer for edges + draft connection + marquee -->
    <svg [attr.height]="svgHeight"
         [attr.viewBox]="svgMinX + ' ' + svgMinY + ' ' + svgWidth + ' ' + svgHeight" [attr.width]="svgWidth"
         [style.left.px]="svgMinX" [style.top.px]="svgMinY"
         class="fc-edges-svg">

      @for (edge of renderedEdges; track edge.id) {
        <g (mousedown)="!connectionDraft && onEdgeMouseDown($event, edge)"
           (mouseenter)="!connectionDraft && (hoveredEdgeId = edge.id)"
           (mouseleave)="hoveredEdgeId = null"
           [class.fc-edge-group--disabled]="!!connectionDraft"
           class="fc-edge-group">
          <path [attr.d]="edge.path"
                class="fc-edge-hitarea" fill="none" stroke="transparent"
                stroke-width="12"/>
          <path [attr.d]="edge.path"
                [attr.stroke-width]="hoveredEdgeId === edge.id ? 2 : (isEdgeConnectedToSelection(edge) ? 2 : 1)"
                [attr.stroke]="hoveredEdgeId === edge.id ? '#EF4444' : (isEdgeConnectedToSelection(edge) ? '#009999' : '#6B7280')"
                class="fc-edge-line" fill="none"/>
          @if (hoveredEdgeId === edge.id) {
            <g class="fc-edge-delete-icon">
              <circle [attr.cx]="(edge.sourceX + edge.targetX) / 2"
                      [attr.cy]="(edge.sourceY + edge.targetY) / 2"
                      fill="#EF4444" r="10"/>
              <line [attr.x1]="(edge.sourceX + edge.targetX) / 2 - 4"
                    [attr.x2]="(edge.sourceX + edge.targetX) / 2 + 4"
                    [attr.y1]="(edge.sourceY + edge.targetY) / 2 - 4"
                    [attr.y2]="(edge.sourceY + edge.targetY) / 2 + 4"
                    stroke="white" stroke-linecap="round" stroke-width="2"/>
              <line [attr.x1]="(edge.sourceX + edge.targetX) / 2 + 4"
                    [attr.x2]="(edge.sourceX + edge.targetX) / 2 - 4"
                    [attr.y1]="(edge.sourceY + edge.targetY) / 2 - 4"
                    [attr.y2]="(edge.sourceY + edge.targetY) / 2 + 4"
                    stroke="white" stroke-linecap="round" stroke-width="2"/>
            </g>
          }
        </g>
      }

      @if (connectionDraft) {
        <g>
          <path [attr.d]="connectionDraft.path"
                [attr.stroke-dasharray]="snappedPort ? 'none' : '6,4'"
                [attr.stroke-width]="snappedPort ? 2 : 2"
                [attr.stroke]="snappedPort ? '#009999' : '#3B82F6'" fill="none"/>
          @if (!snappedPort) {
            <circle [attr.cx]="connectionDraft.currentX"
                    [attr.cy]="connectionDraft.currentY"
                    fill="#3B82F6" opacity="0.6" r="5"/>
          }
        </g>
      }

      <!-- Marquee selection rectangle -->
      @if (marquee) {
        <rect [attr.height]="marquee.h"
              [attr.width]="marquee.w" [attr.x]="marquee.x"
              [attr.y]="marquee.y" class="fc-marquee"/>
      }
    </svg>

    <!-- HTML nodes -->
    @for (node of renderedNodes; track node.id) {
      <div (dblclick)="onNodeDoubleClick($event, node)"
           (mousedown)="onNodeMouseDown($event, node)"
           [class.fc-node--dragging]="draggingNodeId === node.id"
           [class.fc-node--selected]="isNodeSelected(node.id)"
           [ngClass]="getNodeStatusClass(node.id)"
           [style.left.px]="node.x"
           [style.top.px]="node.y"
           [style.width.px]="node.width"
           class="fc-node">

        <div class="fc-node__header">
          <div class="fc-node__cat-badge">
            @if (node.nodeIcon) {
              <fa-icon [icon]="node.nodeIcon" class="text-gray-500" style="font-size: 10px;"></fa-icon>
            } @else {
              {{ node.categoryAbbrev }}
            }
          </div>
          <div class="fc-node__title-area">
            <span class="fc-node__title">{{ node.label }}</span>
            @if (node.summary) {
              <!-- Konfigurations-Zusammenfassung (x-node-summary). Kostet eine Kopfzeile, die in
                   node.headerHeight eingerechnet ist. -->
              <span class="fc-node__summary">{{ node.summary }}</span>
            }
          </div>
          <div (mousedown)="onMenuMouseDown($event, node)"
               class="fc-node__menu">
            <svg fill="#6B7280" height="16" viewBox="0 0 128 512" width="16">
              <path
                d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"/>
            </svg>

            <!-- Context Menu Dropdown -->
            @if (contextMenuNodeId === node.id) {
              <div (mousedown)="$event.stopPropagation()" class="fc-context-menu">
                @if (node.stepRef?.moduleId === 'HYBRID_RULESET_EXECUTOR') {
                  <button (click)="onDrillDownNode(node)"
                          (mousedown)="$event.stopPropagation()"
                          class="fc-context-menu__item">
                    <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path d="M13 7l5 5m0 0l-5 5m5-5H6" stroke-linecap="round" stroke-linejoin="round"
                            stroke-width="2"/>
                    </svg>
                    <span>Prüfregel-Details</span>
                  </button>
                }
                <button (click)="onDeleteNode(node)"
                        (mousedown)="$event.stopPropagation()"
                        class="fc-context-menu__item fc-context-menu__item--danger">
                  <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="2"/>
                  </svg>
                  <span>Löschen</span>
                </button>
              </div>
            }
          </div>
        </div>

        <!-- Nur Flow-Ports: ein Eingang links, je Verzweigungs-Fall ein Ausgang rechts. Werte
             werden im Konfig-Panel gebunden, nicht gezogen. -->
        <div class="fc-node__body">
          <div class="fc-node__ports-left">
            @for (port of node.inputPorts; track $index; let i = $index) {
              <div class="fc-port fc-port--flow">
                <div (mousedown)="onInputPortMouseDown($event)"
                     (mouseup)="onInputPortMouseUp($event, node, i)"
                     [class.fc-port__dot--connected]="port.connected"
                     [class.fc-port__dot--edge-hovered]="isPortEdgeHovered(node.id, 'input', i)"
                     [class.fc-port__dot--edge-selected]="isPortEdgeSelected(node.id, 'input', i)"
                     [class.fc-port__dot--empty]="!port.connected"
                     [class.fc-port__dot--snapped]="isPortSnapped(node.id, i)"
                     class="fc-port__dot fc-port__dot--input">
                </div>
              </div>
            }
          </div>
          <div class="fc-node__ports-right">
            @for (port of node.outputPorts; track $index; let i = $index) {
              <div class="fc-port fc-port--output fc-port--flow">
                <!-- Der generische ▶-Ausgang bleibt labellos; Zweige tragen ihren Namen. -->
                @if (port.name !== '▶') {
                  <span [title]="port.name" class="fc-port__label">{{ port.name }}</span>
                }
                <div (mousedown)="onOutputPortMouseDown($event, node, i)"
                     [class.fc-port__dot--connected]="port.connected"
                     [class.fc-port__dot--edge-hovered]="isPortEdgeHovered(node.id, 'output', i)"
                     [class.fc-port__dot--edge-selected]="isPortEdgeSelected(node.id, 'output', i)"
                     [class.fc-port__dot--empty]="!port.connected"
                     class="fc-port__dot fc-port__dot--output">
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>

